import actionTypes from '../../actions/bill/credit/actionType';

const initialState = {
  drawerVisible: false,
  allOta: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.TOGGLE_CREDIT_DRAWER_VISIBLE:
      const { drawerVisible } = payload;
      return {
        ...state,
        drawerVisible,
      };
    case actionTypes.INIT_ALL_OTA:
      const { allOta } = payload;
      return {
        ...state,
        allOta,
      };
    default:
      return state;
  }
};
